/**
 * 动态地图创建/编辑 payload 组装
 *
 * 职责：
 * 1. buildMapVariableCreatePayload — 统一创建 payload 组装
 * 2. buildMapVariableUpdatePayload — 统一编辑 payload 组装，按类型区分字段
 *
 * 原 master 使用 geometryWgs84，新架构统一使用 geometryGcj02
 */
import { AnchorLayerType, EffectDateType, EffectVehicleType } from '@/utils/constant';

export interface CreatePayloadInput {
  values: Record<string, any>;
  geometryGcj02: any;
  mapId: number | string;
}

export interface UpdatePayloadInput {
  selected: any;
  values: Record<string, any>;
}

/**
 * 组装创建动态地图 payload
 *
 * 轻图测试、导航区等特殊字段（topology、direction、effectVehicleType 等）
 * 已包含在 values 中，此处不特殊处理，统一展开。
 */
export const buildMapVariableCreatePayload = ({
  values,
  geometryGcj02,
  mapId,
}: CreatePayloadInput) => ({
  ...values,
  geometryGcj02,
  mapId,
});

/**
 * 组装编辑动态地图 payload
 *
 * 轻图测试编辑只传 id / remark / effectVehicleType / effectDateType。
 * 导航区编辑额外传 topology / direction。
 * 其他类型传完整字段。
 */
export const buildMapVariableUpdatePayload = ({
  selected,
  values,
}: UpdatePayloadInput): Record<string, any> => {
  if (selected.type === AnchorLayerType.LD_ASSIST) {
    return {
      id: selected.id,
      remark: values.remark,
      effectVehicleType: EffectVehicleType.ALL_EFFECT,
      effectDateType: EffectDateType.PERMANENT,
    };
  }

  return {
    id: selected.id,
    geometryGcj02: selected.geometryGcj02,
    timeLimit: values.timeLimit,
    effectDateType: values.effectDateType,
    remark: values.remark,
    weekLimit: values.weekLimit,
    effectTimeType: values.effectTimeType,
    effectVehicleType: values.effectVehicleType,
    vehicleLimit: values.vehicleLimit,
    status: values.status,
    speedLimit: values.speedLimit,
    topology: values.topology,
    direction: values.direction,
    ...(selected.type === AnchorLayerType.ROAD_CLOSED
      ? { effectiveMapList: values.effectiveMapList }
      : {}),
  };
};
